var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglevrGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0024 3.00061H33.003V33.0012H3.0024V3.00061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4 18.4319C32.4013 17.4036 32.3109 16.3771 32.13 15.3647H18V21.1733H26.073C25.9008 22.0898 25.5451 22.9619 25.0273 23.7374C24.5095 24.5129 23.8403 25.1757 23.0598 25.6859V29.4641H27.927C30.7638 26.8451 32.4 23.0003 32.4 18.4319Z",
    fill: "#FBFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 33.0912C22.05 33.0912 25.4466 31.7556 27.9288 29.4642L23.0616 25.6878C21.7242 26.5878 20.0196 27.1332 18.0018 27.1332C14.1012 27.1332 10.7874 24.5016 9.6012 20.9556H4.6116V24.8274C5.85794 27.3104 7.76997 29.3982 10.1342 30.8575C12.4984 32.3167 15.2217 33.0901 18 33.0912Z",
    fill: "#FBFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.603 20.9412C9.2908 20.0234 9.12911 19.0612 9.1242 18.0918C9.1242 17.0964 9.3024 16.1424 9.603 15.2424V11.3688H4.6116C3.55251 13.4515 3.0011 15.7552 3.0024 18.0918C3.0011 20.4283 3.55251 22.732 4.6116 24.8148L8.4978 21.7872L9.603 20.9412Z",
    fill: "#FBFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.06481C20.2104 9.06481 22.176 9.82801 23.742 11.3004L28.0386 7.00561C25.434 4.57741 22.05 3.09241 18 3.09241C12.1356 3.09241 7.0776 6.45841 4.608 11.3688L9.5994 15.2424C10.7874 11.6964 14.0994 9.06481 18 9.06481Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglevrGrayIcon);
export default __webpack_public_path__ + "static/media/googlevr-gray-icon.f26caa2122b9145e5cf1f4023628e379.svg";
export { ForwardRef as ReactComponent };